import { defineMessages } from 'react-intl';
import {
    ALL_REQUEST,
    CurrentcyPositions,
    DELIVERY_TRIP_DETAIL_STATE_CANCEL,
    DELIVERY_TRIP_DETAIL_STATE_DELIVERING,
    DELIVERY_TRIP_DETAIL_STATE_DONE,
    DELIVERY_TRIP_DETAIL_STATE_PENDING,
    DELIVERY_TRIP_STATE_DELIVERING,
    DELIVERY_TRIP_STATE_DONE,
    DELIVERY_TRIP_STATE_PENDING,
    DEVICE_EXPIRE_DATE_EXPIRE_1_MONTHS,
    DEVICE_EXPIRE_DATE_EXPIRE_1_WEEK,
    DEVICE_EXPIRE_DATE_EXPIRE_2_MONTHS,
    DEVICE_EXPIRE_DATE_EXPIRE_2_WEEK,
    DEVICE_EXPIRE_DATE_NOT_EXPIRED,
    DEVICE_REQUEST_KIND_KITPLAY,
    DEVICE_REQUEST_KIND_ORDER_DISPLAY,
    DEVICE_REQUEST_KIND_PI_SERVER,
    DeviceKinds,
    DISTRICT_KIND,
    DONE_TYPE_VALUE_DONE_IMMEDIATELY,
    DONE_TYPE_VALUE_REQUIRES_APPROVAL,
    ExpiredTypes,
    FOOD_STATUS_SOLD_OUT,
    KITPLAY,
    MediaKinds,
    NEW_REQUEST,
    ORDER_DISPLAY,
    ORDER_DISPLAY_LAYOUT_1,
    ORDER_DISPLAY_LAYOUT_2,
    ORDER_DISPLAY_LAYOUT_3,
    ORDER_STATE_ACTIVE,
    ORDER_STATE_CANCEL,
    ORDER_STATE_DONE,
    ORDER_STATE_HIDE,
    ORDER_STATE_PENDING,
    ORDER_STATE_UNKNOWN,
    PAYMENT_METHOD_MERGE_PORT,
    PAYMENT_METHOD_OFFLINE_CARD,
    PAYMENT_METHOD_OFFLINE_CASH,
    PAYMENT_METHOD_ONLINE_PAYPAL,
    PRINTER_MAPPING_MEDIA_KIND,
    PRINTER_TYPE_KITCHEN,
    PRINTER_TYPE_SERVING,
    PROVINCE_KIND,
    SERVICE_DELIVERY,
    SERVICE_PICKUP,
    SERVICE_QRCODE,
    SERVICE_QRCODE_CUSTOMER,
    STATUS_ACTIVE,
    STATUS_LOCK,
    STATUS_PENDING,
    ValueTypes,
    VILLAGE_KIND,
    VOUCHER_STATE_ACTIVE,
    VOUCHER_STATE_DONE,
    VOUCHER_STATE_EXPIRED,
    VOUCHER_STATE_PENDING,
    VOUCHER_STATE_SCHEDULED,
    VOUCHER_TYPE_AMOUNT,
    VOUCHER_TYPE_PERCENT,
} from '@constants';

import { expireKitplayMessage, nationKindMessage } from './intl';

const commonMessage = defineMessages({
    statusActive: 'Active',
    statusPending: 'Pending',
    statusInactive: 'Inactive',
    lock: 'Lock',
    statusLock: 'Lock',
    DEVICE_TYPE_TABLE_QRCODE: 'Table Show Order QR Code',
    DEVICE_TYPE_ORDER_QRCODE: 'Ordercon',
    DEVICE_TYPE_TABLET_RANDOM_QRCODE: 'QR Live',
    DEVICE_TYPE_POS: 'Partner',
    DEVICE_TYPE_TABLET_BOARD: 'Table Board',
    DEVICE_TYPE_PAYMENT: 'Payment',
    kind1001: 'Full feature',
    kind1002: 'Receive orders',
    kind1003: 'Delivery orders',
    kind1004: 'Table QR code',
    image: 'Image',
    video: 'Video',
    offlineCash: 'Cash',
    offlineCard: 'Direct card payment',
    onlinePaypal: 'Paypal',
    singleChoice: 'Single choice',
    multiChoice: 'Multiple choice',
    newRequest: 'Has new request',
    allRequest: 'All restaurant',
    hasRestaurant: 'Has restaurant',
    allShop: 'All shop account',
    kitplay: 'KITPLAY',
    orderDisplay: 'PICKUP DISPLAY',
    layout1: 'Layout 1',
    layout2: 'Layout 2',
    layout3: 'Layout 3',
    deviceKind101: 'Ordercon',
    doneImmediately: 'Done immediately',
    requiresApproval: 'Requires approval',
    printerMapping: 'Printer mapping',
    printerTypeKitchen: 'Kitchen',
    printerTypeDelivery: 'Delivery',

    deliveryTripStatePending: 'Pending',
    deliveryTripStateDelivering: 'Delivering',
    deliveryTripStateDone: 'Done',

    voucherPercent: 'Percentage',
    voucherAmount: 'Amount',
    doneType: 'Done type',
    expired: 'Expired',

    orderStateUnknown: 'Unknown',
    orderStatePending: 'Pending',
    orderStateActive: 'Preparing',
    orderStateDone: 'Done',
    orderStateCancel: 'Cancel',
    orderStateHide: 'Archive',

    mergeport: 'Mergeport',

    deliveryTripDetailStateCancel: 'Cancel',
    deliveryTripDetailStatePending: 'Pending',
    deliveryTripDetailStateDelivering: 'Delivering',
    deliveryTripDetailStateDone: 'Done',

    piServer: 'Pi Server',
    digibes: 'Digibes',

    regularFood: 'Regular food',
    selectableFood: 'Selectable food',
    soldOut: 'Sold out',

    drink: 'Drink',
    food: 'Food',

    fixed: 'Fixed',
    percentage: 'Percentage',
    scheduled: 'Scheduled',
});

export const dayOfWeek = defineMessages({
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
});

export const dayOfWeekHappyHour = defineMessages({
    monday: 'Mon',
    tuesday: 'Tue',
    wednesday: 'Wed',
    thursday: 'Thu',
    friday: 'Fri',
    saturday: 'Sat',
    sunday: 'Sun',
});

export const media = defineMessages({
    media1: 'Media 1',
    media2: 'Media 2',
    media3: 'Media 3',
    media4: 'Media 4',
    media5: 'Media 5',
});

export const languageOptions = [
    { value: 1, label: 'EN' },
    { value: 2, label: 'VN' },
    { value: 3, label: 'Other' },
];

export const orderOptions = [
    { value: 1, label: '1' },
    { value: 2, label: '2' },
    { value: 3, label: '3' },
];

export const commonStatus = [
    {
        value: STATUS_ACTIVE,
        label: 'Active',
        color: 'green',
    },
    { value: STATUS_LOCK, label: 'Lock', color: 'red' },
    // { value: STATUS_ACTIVE, label: 'Active', color: 'green' },
    // { value: STATUS_PENDING, label: 'Pending', color: 'warning' },
    // { value: STATUS_INACTIVE, label: 'Inactive', color: 'red' },
];

export const statusOptions = [
    { value: STATUS_ACTIVE, label: commonMessage.statusActive, color: '#00A648' },
    // { value: STATUS_PENDING, label: commonMessage.statusPending, color: '#FFBF00' },
    // { value: STATUS_INACTIVE, label: commonMessage.statusInactive, color: '#CC0000' },
    // { value: STATUS_LOCK, label: commonMessage.lock, color: '#CC0000' },
    { value: STATUS_LOCK, label: commonMessage.statusLock, color: '#FFBF00' },
    // { value: STATUS_INACTIVE, label: commonMessage.statusInactive, color: '#CC0000' },
];

export const datetimeFormats = [
    { value: 'dd.MM.yyyy', label: 'dd.MM.yyyy' },
    { value: 'yyyy.MM.dd', label: 'yyyy.MM.dd' },
];

export const currentcyPositions = [
    { value: CurrentcyPositions.FRONT, label: '$ 1234,56' },
    { value: CurrentcyPositions.BACK, label: '1234,56 $' },
];

export const formSize = {
    small: '700px',
    normal: '800px',
    big: '900px',
};

export const nationKindOptions = [
    {
        value: PROVINCE_KIND,
        label: nationKindMessage.province,
    },
    {
        value: DISTRICT_KIND,
        label: nationKindMessage.district,
    },
    {
        value: VILLAGE_KIND,
        label: nationKindMessage.village,
    },
];

export const restaurantServices = [
    // { value: 'QRCODE', label: 'QRCODE' },
    {
        value: 'QRCODE_CUSTOMER',
        label: 'QRCODE_LIVE',
    },
    { value: 'PICKUP', label: 'PICKUP' },
    { value: 'DELIVERY', label: 'DELIVERY' },
    { value: KITPLAY, label: 'KITPLAY' },
    { value: ORDER_DISPLAY, label: 'PICKUP_DISPLAY' },
];
export const paypalCurrentcyCodes = [
    { label: 'Australian dollar (AUD)', value: 'AUD' },
    { label: 'Brazilian real 2 (BRL)', value: 'BRL' },
    { label: 'Canadian dollar (CAD)', value: 'CAD' },
    { label: 'Chinese Renmenbi 4 (CNY)', value: 'CNY' },
    { label: 'Czech koruna (CZK)', value: 'CZK' },
    { label: 'Danish krone (DKK)', value: 'DKK' },
    { label: 'Euro (EUR)', value: 'EUR' },
    { label: 'Hong Kong dollar (HKD)', value: 'HKD' },
    { label: 'Hungarian forint 1 (HUF)', value: 'HUF' },
    { label: 'Indian rupee 3 (INR)', value: 'INR' },
    { label: 'Israeli new shekel (ILS)', value: 'ILS' },
    { label: 'Japanese yen 1 (JPY)', value: 'JPY' },
    { label: 'Malaysian ringgit 4 (MYR)', value: 'MYR' },
    { label: 'Mexican peso (MXN)', value: 'MXN' },
    { label: 'New Taiwan dollar 1 (TWD)', value: 'TWD' },
    { label: 'New Zealand dollar (NZD)', value: 'NZD' },
    { label: 'Norwegian krone (NOK)', value: 'NOK' },
    { label: 'Philippine peso (PHP)', value: 'PHP' },
    { label: 'Polish złoty (PLN)', value: 'PLN' },
    { label: 'Pound sterling (GBP)', value: 'GBP' },
    { label: 'Russian ruble (RUB)', value: 'RUB' },
    { label: 'Singapore dollar (SGD)', value: 'SGD' },
    { label: 'Swedish krona (SEK)', value: 'SEK' },
    { label: 'Swiss franc (CHF)', value: 'CHF' },
    { label: 'Thai baht (THB)', value: 'THB' },
    { label: 'United States dollar (USD)', value: 'USD' },
];

export const commonLanguages = [
    { value: 'vi', label: 'Việt Nam' },
    { value: 'en', label: 'English' },
    { value: 'de', label: 'German' },
];
export const RestaurantStatus = [
    {
        value: STATUS_ACTIVE,
        label: commonMessage.statusActive,
        color: 'green',
    },
    {
        value: STATUS_LOCK,
        label: commonMessage.statusLock,
        color: 'red',
    },
];
export const expiredTypes = [
    { value: ExpiredTypes.EXPIRED, label: 'Expired' },
    {
        value: ExpiredTypes.NEXT_MONTH_1,
        label: 'Next 1 Month',
    },
    {
        value: ExpiredTypes.NEXT_MONTH_2,
        label: 'Next 2 Month',
    },
    {
        value: ExpiredTypes.NEXT_MONTH_3,
        label: 'Next 3 Month',
    },
    {
        value: ExpiredTypes.NEXT_MONTH_4,
        label: 'Next 4 Month',
    },
];

export const deviceKinds = [
    // {
    //     value: DeviceKinds.DEVICE_TYPE_TABLE_QRCODE,
    //     label: 'Table Show Order QR Code' },
    {
        value: DeviceKinds.DEVICE_TYPE_ORDER_QRCODE,
        label: commonMessage.DEVICE_TYPE_ORDER_QRCODE,
    },
    {
        value: DeviceKinds.DEVICE_TYPE_TABLET_RANDOM_QRCODE,
        label: commonMessage.DEVICE_TYPE_TABLET_RANDOM_QRCODE,
    },
    {
        value: DeviceKinds.DEVICE_TYPE_POS,
        label: commonMessage.DEVICE_TYPE_POS,
    },
];

export const orderconDeviceKinds = [
    // {
    //     value: DeviceKinds.DEVICE_TYPE_TABLE_QRCODE,
    //     label: 'Table Show Order QR Code' },
    {
        value: DeviceKinds.DEVICE_TYPE_ORDER_QRCODE,
        label: commonMessage.DEVICE_TYPE_ORDER_QRCODE,
    },
    // {
    //     value: DeviceKinds.DEVICE_TYPE_TABLET_RANDOM_QRCODE,
    //     label: commonMessage.DEVICE_TYPE_TABLET_RANDOM_QRCODE,
    // },
    {
        value: DeviceKinds.DEVICE_TYPE_POS,
        label: commonMessage.DEVICE_TYPE_POS,
    },
];

export const qrliveDeviceKinds = [
    // {
    //     value: DeviceKinds.DEVICE_TYPE_TABLE_QRCODE,
    //     label: 'Table Show Order QR Code' },
    // {
    //     value: DeviceKinds.DEVICE_TYPE_ORDER_QRCODE,
    //     label: commonMessage.DEVICE_TYPE_ORDER_QRCODE,
    // },
    {
        value: DeviceKinds.DEVICE_TYPE_TABLET_RANDOM_QRCODE,
        label: commonMessage.DEVICE_TYPE_TABLET_RANDOM_QRCODE,
    },
    // {
    //     value: DeviceKinds.DEVICE_TYPE_POS,
    //     label: commonMessage.DEVICE_TYPE_POS,
    // },
];

export const tabletOrderQrCodeTypes = [
    {
        value: 1001,
        label: commonMessage.kind1001,
    },
    {
        value: 1002,
        label: commonMessage.kind1002,
    },
    {
        value: 1003,
        label: commonMessage.kind1003,
    },
];

export const mediaKinds = [
    { value: MediaKinds.IMAGE, label: commonMessage.image },
    { value: MediaKinds.VIDEO, label: commonMessage.video },
];

export const daysOfWeekTimeWork = [
    { value: 'monday', label: dayOfWeek.monday },
    { value: 'tuesday', label: dayOfWeek.tuesday },
    { value: 'wednesday', label: dayOfWeek.wednesday },
    { value: 'thursday', label: dayOfWeek.thursday },
    { value: 'friday', label: dayOfWeek.friday },
    { value: 'saturday', label: dayOfWeek.saturday },
    { value: 'sunday', label: dayOfWeek.sunday },
];

export const daysOfWeekSchedule = [
    { value: 1, label: dayOfWeekHappyHour.monday },
    { value: 2, label: dayOfWeekHappyHour.tuesday },
    { value: 3, label: dayOfWeekHappyHour.wednesday },
    { value: 4, label: dayOfWeekHappyHour.thursday },
    { value: 5, label: dayOfWeekHappyHour.friday },
    { value: 6, label: dayOfWeekHappyHour.saturday },
    { value: 7, label: dayOfWeekHappyHour.sunday },
];

export const mediaCodes = [
    { value: 'MEDIA_CODE_1', label: media.media1 },
    { value: 'MEDIA_CODE_2', label: media.media2 },
    { value: 'MEDIA_CODE_3', label: media.media3 },
    { value: 'MEDIA_CODE_4', label: media.media4 },
    { value: 'MEDIA_CODE_5', label: media.media5 },
];

export const orderMethods = [
    { value: 'OFFLINE_CASH', label: commonMessage.offlineCash },
    { value: 'OFFLINE_CARD', label: commonMessage.offlineCard },
    { value: 'ONLINE_PAYPAL', label: commonMessage.onlinePaypal },
];

const GoodsKinds = {
    COMMON: 1,
    CHOOSE: 5,
    // MERGE: 3,
    // CHOOSE: 4
};

export const goodsKinds = [
    { value: GoodsKinds.COMMON, label: commonMessage.regularFood },
    // { value: GoodsKinds.MERGE, label: 'Món ăn gộp'},
    { value: GoodsKinds.CHOOSE, label: commonMessage.selectableFood },
];
export const foodStatus = [
    {
        value: STATUS_ACTIVE,
        label: commonMessage.statusActive,
        color: 'green',
    },
    // { value: STATUS_INACTIVE, label: 'Inactive', color: 'warning' },
    { value: STATUS_LOCK, label: commonMessage.lock, color: 'red' },
    {
        value: FOOD_STATUS_SOLD_OUT,
        label: commonMessage.soldOut,
        color: 'orange',
    },
];

const GoodsTypes = {
    DRINK: 1,
    FOOD: 2,
};

export const goodsTypes = [
    { value: GoodsTypes.DRINK, label: commonMessage.drink },
    { value: GoodsTypes.FOOD, label: commonMessage.food },
];

export const beilageItemTypes = [
    { value: 0, label: commonMessage.singleChoice },
    { value: 1, label: commonMessage.multiChoice },
];

export const valueTypes = [
    { value: ValueTypes.FIXED, label: commonMessage.fixed },
    { value: ValueTypes.PERCENTAGE, label: commonMessage.percentage },
];
export const codeThirdParty = [
    {
        value: 'MERGE_PORT',
        label: 'Mergeport',
    },
];

export const deviceStatus = [
    { value: STATUS_ACTIVE, label: commonMessage.statusActive, color: '#00A648' },
    { value: STATUS_PENDING, label: commonMessage.statusPending, color: '#FFBF00' },
];

export const doneType = [
    { value: DONE_TYPE_VALUE_DONE_IMMEDIATELY, label: commonMessage.doneImmediately },
    { value: DONE_TYPE_VALUE_REQUIRES_APPROVAL, label: commonMessage.requiresApproval },
];

export const orderDisplayLayouts = [
    { value: ORDER_DISPLAY_LAYOUT_1, label: commonMessage.layout1 },
    { value: ORDER_DISPLAY_LAYOUT_2, label: commonMessage.layout2 },
    { value: ORDER_DISPLAY_LAYOUT_3, label: commonMessage.layout3 },
];

export const expireKitplayOptions = [
    {
        value: DEVICE_EXPIRE_DATE_NOT_EXPIRED,
        label: expireKitplayMessage.notExpire,
    },
    {
        value: DEVICE_EXPIRE_DATE_EXPIRE_1_WEEK,
        label: expireKitplayMessage.expireOneWeek,
    },
    {
        value: DEVICE_EXPIRE_DATE_EXPIRE_2_WEEK,
        label: expireKitplayMessage.expireTwoWeek,
    },
    {
        value: DEVICE_EXPIRE_DATE_EXPIRE_1_MONTHS,
        label: expireKitplayMessage.expireOneMonth,
    },
    {
        value: DEVICE_EXPIRE_DATE_EXPIRE_2_MONTHS,
        label: expireKitplayMessage.expireTwoMonth,
    },
];

export const getCurrencyPositionMessage = (
    defaultCurrency = '$',
    defaultGroupSeparator = '.',
    defaultDecimalSeparator = ',',
    decimalSpace = 0,
) => {
    const validDecimalSpace = parseInt(decimalSpace, 10) || 0;
    const integerPart = '123' + defaultGroupSeparator + '456';
    const decimalPart = validDecimalSpace > 0 ? Array(validDecimalSpace).fill('0').join('') : '';
    const formattedNumber = decimalPart ? `${integerPart}${defaultDecimalSeparator}${decimalPart}` : integerPart;

    return {
        front: `${defaultCurrency} ${formattedNumber}`,
        back: `${formattedNumber} ${defaultCurrency}`,
    };
};

export const getCurrencyPosition = (
    defaultCurrency = '$',
    defaultGroupSeparator = '.',
    defaultDecimalSeparator = ',',
    decimalSpace = 0,
) => {
    const currencyPositionMessage = getCurrencyPositionMessage(
        defaultCurrency,
        defaultGroupSeparator,
        defaultDecimalSeparator,
        decimalSpace,
    );
    return [
        { value: 0, label: currencyPositionMessage.front },
        { value: 1, label: currencyPositionMessage.back },
    ];
};

export const DEVICE_KIND_101 = 101;
export const DEVICE_SUB_KIND_1001 = 1001;

export const TABLET_DEVICE_TYPE_ORDER_QRCODE = 101;

export const deviceKindOptions = [
    {
        value: DEVICE_KIND_101,
        label: commonMessage.deviceKind101,
    },
];

export const deviceSubKindOptions = [
    {
        value: DEVICE_SUB_KIND_1001,
        label: commonMessage.kind1001,
    },
];

export const hasTabletRequestOptions = [
    { value: ALL_REQUEST, label: commonMessage.allRequest, color: '#FFBF00' },
    { value: NEW_REQUEST, label: commonMessage.newRequest, color: '#00A648' },
];


export const serviceOptions = [
    { value: KITPLAY, label: 'KITPLAY' },
    { value: ORDER_DISPLAY, label: 'PICKUP DISPLAY' },
];

export const mediaCategoryOptions = [
    { value: PRINTER_MAPPING_MEDIA_KIND, label: commonMessage.printerMapping },
];

export const printerTypeOptions = [
    { value: PRINTER_TYPE_KITCHEN, label: commonMessage.printerTypeKitchen },
    { value: PRINTER_TYPE_SERVING, label: commonMessage.printerTypeDelivery },
];

export const deliveryTripStateOptions = [
    { value: DELIVERY_TRIP_STATE_PENDING, label: commonMessage.deliveryTripStatePending, color: 'yellow' },
    { value: DELIVERY_TRIP_STATE_DELIVERING, label: commonMessage.deliveryTripStateDelivering, color: 'blue' },
    { value: DELIVERY_TRIP_STATE_DONE, label: commonMessage.deliveryTripStateDone, color: 'green' },
];

export const voucherTypeOptions = [
    { value: VOUCHER_TYPE_PERCENT, label: commonMessage.voucherPercent, color: 'purple' },
    { value: VOUCHER_TYPE_AMOUNT, label: commonMessage.voucherAmount, color: 'geekblue' },
];

export const orderStateOptions = [
    { value: ORDER_STATE_PENDING, label: commonMessage.orderStatePending, color: 'orange' },
    { value: ORDER_STATE_ACTIVE, label: commonMessage.orderStateActive, color: 'blue' },
    { value: ORDER_STATE_DONE, label: commonMessage.orderStateDone, color: 'green' },
    { value: ORDER_STATE_CANCEL, label: commonMessage.orderStateCancel, color: 'red' },
    { value: ORDER_STATE_UNKNOWN, label: commonMessage.orderStateUnknown, color: 'grey' },
    { value: ORDER_STATE_HIDE, label: commonMessage.orderStateHide, color: 'purple' },
];

export const paymentMethodOptions = [
    { value: PAYMENT_METHOD_OFFLINE_CASH, label: commonMessage.offlineCash },
    { value: PAYMENT_METHOD_OFFLINE_CARD, label: commonMessage.offlineCard },
    { value: PAYMENT_METHOD_ONLINE_PAYPAL, label: commonMessage.onlinePaypal },
    { value: PAYMENT_METHOD_MERGE_PORT, label: commonMessage.mergeport },
];

export const orderKindOptions = [
    { value: SERVICE_PICKUP, label: 'PICKUP' },
    { value: SERVICE_DELIVERY, label: 'DELIVERY' },
    { value: SERVICE_QRCODE, label: 'QRCODE' },
    { value: SERVICE_QRCODE_CUSTOMER, label: 'QRCODE_CUSTOMER' },
];

export const deliveryTripDetailStateOptions = [
    { value: DELIVERY_TRIP_DETAIL_STATE_PENDING, label: commonMessage.deliveryTripDetailStatePending, color: 'orange' },
    { value: DELIVERY_TRIP_DETAIL_STATE_DELIVERING, label: commonMessage.deliveryTripDetailStateDelivering, color: 'blue' },
    { value: DELIVERY_TRIP_DETAIL_STATE_DONE, label: commonMessage.deliveryTripDetailStateDone, color: 'green' },
    { value: DELIVERY_TRIP_DETAIL_STATE_CANCEL, label: commonMessage.deliveryTripDetailStateCancel, color: 'red' },
];

export const deliveryTripDetailOSMMapTypes = [
    { value: DELIVERY_TRIP_DETAIL_STATE_DELIVERING, label: commonMessage.deliveryTripDetailStateDelivering, color: '#ff8c00' },
    { value: DELIVERY_TRIP_DETAIL_STATE_DONE, label: commonMessage.deliveryTripDetailStateDone, color: '#038a19' },
];


export const voucherStateOptions = [
    { value: VOUCHER_STATE_PENDING, label: commonMessage.statusPending, color: 'yellow' },
    { value: VOUCHER_STATE_ACTIVE, label: commonMessage.statusActive, color: 'green' },
    { value: VOUCHER_STATE_SCHEDULED, label: commonMessage.scheduled, color: 'orange' },
    { value: VOUCHER_STATE_DONE, label: commonMessage.doneType, color: 'blue' },
];

export const voucherUpdateStateOptions = [
    { value: VOUCHER_STATE_PENDING, label: commonMessage.statusPending, color: 'yellow' },
    { value: VOUCHER_STATE_ACTIVE, label: commonMessage.statusActive, color: 'green' },
];